var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes },
    [
      _vm.showHeader
        ? _c("div", { class: _vm.namespace("header") }, [
            _c(
              "span",
              { class: _vm.namespace("header__title") },
              [_vm._t("title")],
              2
            ),
            _vm._v(" "),
            _c("div", { class: _vm.mdsNS("popover__overlay") }),
            _vm._v(" "),
            _c("div", { class: _vm.mdsNS("button-icon-wrap") }, [
              _vm.showExport
                ? _c(
                    "button",
                    {
                      ref: "exportButton",
                      class: _vm.exportBtnClassess,
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.clickExport($event)
                        }
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          class: _vm.mdsNS("icon button__icon"),
                          attrs: { "aria-hidden": "true" }
                        },
                        [
                          _c("use", { attrs: { "xlink:href": "#share" } }, [
                            _c("title", [_vm._v("Settings")])
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showSetting
                ? _c(
                    "button",
                    {
                      ref: "settingsButton",
                      class: _vm.settingBtnClassess,
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.clickSetting($event)
                        }
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          class: _vm.mdsNS("icon button__icon"),
                          attrs: { "aria-hidden": "true" }
                        },
                        [
                          _c("use", { attrs: { "xlink:href": "#gear" } }, [
                            _c("title", [_vm._v("Settings")])
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.namespace("body") },
        [
          !!_vm.errorMessage
            ? _c("markets-ui-alert", {
                class: _vm.namespace("body-alert"),
                attrs: {
                  namespaced: _vm.namespaced,
                  message: _vm.errorMessage,
                  skin: _vm.skin,
                  visible: !!_vm.errorMessage
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._t("content")
        ],
        2
      ),
      _vm._v(" "),
      _c("markets-ui-loading", {
        attrs: {
          namespaced: _vm.namespaced,
          skin: _vm.skin,
          visible: _vm.showLoading
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }